import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const instance = axios.create({
  // baseURL: `http://localhost:3005/`,
  baseURL: `https://prjx.us`
});

// Request interceptor
instance.interceptors.request.use(
  (config) => {
    if (config.data instanceof FormData) {
      // If FormData, set the Content-Type header to multipart/form-data
      config.headers["Content-Type"] = "multipart/form-data";
    } else {
      // For other types of data, set the Content-Type header to application/json
      config.headers["Content-Type"] = "application/json";
    }

    const authToken = localStorage.getItem("token");

    if (authToken) {
      config.headers["Authorization"] = `Bearer ${authToken}`;
    }

    return config;
  },
  (error) => {
    toast.error("An error occurred while sending the request."); // Display a toast for request errors
    return Promise.reject(error);
  }
);

// Response interceptor
instance.interceptors.response.use(
  (response) => {
    // if 401 then redirect to login
    console.log("Response:", response);
    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/";
    }

    // You can customize this to show success toasts for specific responses
    if (response.status === 200) {
      // message is a property in the response data
      if (response.data.message) {
        toast.success(response.data.message);
      }
    }
    return response;
  },
  (error) => {
    console.error(error);
    if (error.response && error.response.status === 401) {
      toast.error(error.response.data.message);
      localStorage.clear();
      window.location.href = "/";
    } else if (error.response && error.response.status === 500) {
      toast.error("Server error. Please try again later.");
    } else {
      // error.message is a property in the error object
      toast.error(error.response.data.message);
    }
    return Promise.reject(error);
  }
);

export default instance;
